// Wire types for manual play (Module 3), shared by the backend play runner and the
// frontend play UI. A run is stateless + replayable: the client holds the action
// list and a seed; the backend replays from the start each time and returns the
// full transcript + final state. Same seed + same actions ⇒ same result.
import { ScannableResourceSelectionType } from './contracts';
/** Max transmitters equippable per run (game: 4 slots). */
export const MAX_TRANSMITTERS = 4;
// A tiny stable string hash (FNV-1a) — for the deterministic `Random` subset so a
// cell reveals the same resources every replay without touching the run's rng.
function hashStr(s) {
    let h = 0x811c9dc5;
    for (let i = 0; i < s.length; i++) {
        h ^= s.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
    }
    return h >>> 0;
}
/** The resources a scanned cell yields, resolved against the catalog. `All` → the
 *  whole catalog; `Custom` → the authored list; `Random` → a stable per-cell half
 *  of the pool (authored list if any, else the catalog). Deterministic per coord. */
export function revealScannableResources(cell, coord, catalog) {
    var _a, _b;
    if (!cell.hasScannableResources)
        return [];
    const byId = new Map(catalog.map(r => [r.id, r]));
    const listed = ((_a = cell.scannableResourcesList) !== null && _a !== void 0 ? _a : [])
        .map(id => byId.get(id)).filter((r) => !!r);
    const type = (_b = cell.scannableResourcesType) !== null && _b !== void 0 ? _b : ScannableResourceSelectionType.Custom;
    if (type === ScannableResourceSelectionType.All)
        return catalog;
    if (type === ScannableResourceSelectionType.Custom)
        return listed;
    // Random: a stable ~half subset of the pool, ordered by a coord-seeded hash.
    const pool = listed.length ? listed : catalog;
    if (pool.length <= 1)
        return pool;
    const ranked = [...pool].sort((a, b) => hashStr(coord + a.id) - hashStr(coord + b.id));
    return ranked.slice(0, Math.max(1, Math.ceil(pool.length / 2)));
}
